"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateNetAmount = exports.calculateGrossAmount = exports.calculateHighPrecisionNetPrice = exports.calculateHighPrecisionGrossPrice = exports.calculateGrossPrice = void 0;
const common_1 = require("./common");
const money_1 = require("./money");
const highPrecisionFractionMultiplier = 10 ** common_1.highPrecisionFractionDigits;
function calculateGrossPrice(preciseAmount, taxRate, currencyCode) {
    const currencyFractionDigits = (0, common_1.getCurrencyFractionDigits)(currencyCode);
    const preciseAmountWithFraction = preciseAmount / highPrecisionFractionMultiplier;
    const centAmount = calculateGrossAmount(preciseAmountWithFraction, taxRate, currencyFractionDigits);
    return {
        type: 'centPrecision',
        currencyCode,
        centAmount,
    };
}
exports.calculateGrossPrice = calculateGrossPrice;
function calculateHighPrecisionGrossPrice(preciseAmount, taxRate, currencyCode) {
    const { centAmount } = calculateGrossPrice(preciseAmount, taxRate, currencyCode);
    const preciseAmountWithFraction = preciseAmount / highPrecisionFractionMultiplier;
    return {
        type: 'highPrecision',
        currencyCode,
        centAmount,
        preciseAmount: calculateGrossAmount(preciseAmountWithFraction, taxRate, common_1.highPrecisionFractionDigits),
        fractionDigits: common_1.highPrecisionFractionDigits,
    };
}
exports.calculateHighPrecisionGrossPrice = calculateHighPrecisionGrossPrice;
function calculateHighPrecisionNetPrice({ preciseAmount, currencyCode, fractionDigits }, taxRate) {
    const currencyFractionDigits = (0, common_1.getCurrencyFractionDigits)(currencyCode);
    const preciseAmountWithFraction = preciseAmount / 10 ** fractionDigits;
    return {
        type: 'highPrecision',
        currencyCode,
        centAmount: calculateNetAmount(preciseAmountWithFraction, taxRate, currencyFractionDigits),
        preciseAmount: calculateNetAmount(preciseAmountWithFraction, taxRate, fractionDigits),
        fractionDigits,
    };
}
exports.calculateHighPrecisionNetPrice = calculateHighPrecisionNetPrice;
function calculateGrossAmount(netAmountWithFraction, taxRate, fractionDigits = common_1.highPrecisionFractionDigits) {
    return (0, money_1.toPrecisionNumber)(netAmountWithFraction * taxRate + netAmountWithFraction, fractionDigits);
}
exports.calculateGrossAmount = calculateGrossAmount;
function calculateNetAmount(grossAmountWithFaction, taxRate, fractionDigits = common_1.highPrecisionFractionDigits) {
    return (0, money_1.toPrecisionNumber)(grossAmountWithFaction / (taxRate + 1), fractionDigits);
}
exports.calculateNetAmount = calculateNetAmount;
//# sourceMappingURL=taxedPrice.js.map